import React, { useState } from "react"
import PropTypes from "prop-types"
import { Grid, Typography, TextField,Button, Stack } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import CheckIcon from '@mui/icons-material/Check';
import { postLeadWithoutLoginFetch } from "../../fetch/index/agentNew"

import { checkEmail, checkPhone } from "../../commons/helps";
import {alpha} from "@mui/material/styles";
const LeadsFormComponent = (props) => {

    const { leadsWeclome, leadsInfo, converationId, globalparams } = props;
    const [loading, setLoading] = useState(false);
    const [newLeadsInfo, setNewLeadsInfo] = useState(leadsInfo)
    const [buttonDisabled, setButtonDisabled] = useState(false)
    const formDisabled = () => {
        let isDisabled = false;
        newLeadsInfo.forEach(item => {
            if (item.value === "" || item.error) {
                isDisabled = true
            }
        });
        return isDisabled
    }
    const submitEventForm = async () => {
        setLoading(true)

        let data = {}
        newLeadsInfo.forEach(item => {
            data[item.key] = item.value;
        })
        try {
            await postLeadWithoutLoginFetch(converationId, data)
            localStorage.setItem("leads", true)
            setButtonDisabled(true)
        } catch (error) {

        }
        setLoading(false)
    }
    const leadsInfoCallBack = (index, value) => {
        const newValue = JSON.parse(JSON.stringify(newLeadsInfo))
        newValue.forEach((item, key) => {
            if (key === index) {
                item.value = value;
                if (item.key === "email" && !checkEmail(item.value)) {
                    item.error = "Please check if the email format is correct";
                } else if (item.key === "email" && checkEmail(item.value)) {
                    item.error = false;
                } else if (item.key === "phone") {
                    item.error = false;
                }
            }
        });
        setNewLeadsInfo(newValue)
    }

    const buttonColor = globalparams?.userMessageBg ?? '#1976d2';
    const textColor   = globalparams?.userMessageText ?? '#fff';

    return (
        <Grid sx={{
            mt: 1,
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1,
            mb: 2,
            flexDirection: { xs: 'column', sm: 'column' },
        }}>
            <Typography variant="body2" sx={{ marginTop: "10px" }}>{leadsWeclome}</Typography>
            <Stack spacing={2} sx={{ p: 2, backgroundColor: '#f9f9f9', borderRadius: 2 }}>
                {
                    newLeadsInfo?.map?.((item, index) => {
                        return (
                                <TextField
                                    disabled={buttonDisabled}
                                    inputProps={{ maxLength: 60 }}
                                    fullWidth
                                    label={item.label}
                                    variant="outlined"
                                    error={Boolean(item.error)}
                                    // helperText={item.error}
                                    InputProps={{
                                        startAdornment: <></>,
                                    }}
                                    onChange={(e) => {
                                        leadsInfoCallBack(index, e?.target?.value)
                                    }}
                                    sx={{
                                        typography: 'body2',
                                        borderRadius: 2,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            '& fieldset': { borderRadius: 2 },
                                            '&.Mui-focused fieldset': { borderColor: buttonColor }
                                        },
                                        '& label.Mui-focused': { color: buttonColor }
                                    }}
                                />


                        )
                    })
                }

                <Button
                    loading={loading}
                    loadingPosition="start"
                    variant="contained"
                    onClick={submitEventForm}
                    disabled={formDisabled() || buttonDisabled}
                    fullWidth
                    sx={{
                        typography: 'body2',
                        px: 2,
                        py: 1.5,
                        borderRadius: 2,
                        color: textColor,
                        backgroundColor: buttonColor,
                        '&:hover': { backgroundColor: alpha(buttonColor, 0.85) },
                    }}
                >
                    Submit
                </Button>
            </Stack>

        </Grid>
    );
};
LeadsFormComponent.propTypes = {
    leadsWeclome: PropTypes.any,
    leadsInfo: PropTypes.any,
    converationId: PropTypes.any,
    globalparams: PropTypes.any,
}
export default LeadsFormComponent;